import React from 'react'
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react'

type FallbackProps = { withPadding?: boolean }

const Fallback: React.FC<FallbackProps> = props => {
  const className = props.withPadding ? 'p' : undefined
  return (
    <div role="alert" className={className}>
      Something went wrong.
    </div>
  )
}

type ErrorBoundaryProps = {
  children: React.ReactNode
  fallback?: React.ReactElement | React.FC<FallbackProps>
  withPadding?: boolean
}

const ErrorBoundary = (props: ErrorBoundaryProps) => {
  const { children, fallback = Fallback, withPadding = false } = props
  const fallbackElement = React.isValidElement<FallbackProps>(fallback)
    ? React.cloneElement<FallbackProps>(fallback, { withPadding })
    : React.createElement(fallback as React.FC<FallbackProps>, { withPadding })
  return <SentryErrorBoundary fallback={fallbackElement}>{children}</SentryErrorBoundary>
}

export default ErrorBoundary
